import React from 'react'
import { Segment } from 'components/segment/Segment';
import SEO from 'components/seo';

export default () => (
    <>
        <SEO title="Policy page" />
        <Segment>
            <div  style={{minHeight:'100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                This is Policy page..!
            </div>
        </Segment>
    </>
    )
